module.exports = __webpack_public_path__ + "assets/pdf/cabernet-sauvignon.d1dfbdc8.pdf";